"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupRegisterReducer = exports.groupRegisterActions = exports.TYPES = exports.TEMPLATE_NM = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'groupRegister';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_CONTENT: PREFIX + 'SetContent',
  SET_CREATOR: PREFIX + 'SetCreator',
  SET_GROUP_NM: PREFIX + 'SetGroupNm',
  SET_USERS: PREFIX + 'SetUsers',
  SET_ADMINS: PREFIX + 'SetAdmins',
  // 組織名の表示切替
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  CHANGE_SHOW_ALL_ADMIN: PREFIX + 'ChangeShowAllAdmin',
  // チェック状態変更
  CHANGE_CHECKED: PREFIX + 'ChangeChecked',
  //管理者チェック状態変更
  CHANGE_CHECKED_ADMIN: PREFIX + 'ChangeCheckedAdmin',
  // チェック状態変更（ページ全て）
  CHANGE_CHECKED_ALL: PREFIX + 'ChangeCheckedAll',
  CHANGE_CHECKED_ALL_ADMIN: PREFIX + 'ChangeCheckedAllAdmin',
  // ページングリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_PAGE_ADMIN: PREFIX + 'ChangePageAdmin',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_VIEW_NUM_ADMIN: PREFIX + 'ChangeViewNumAdmin',
  DELETE_CHECKED: PREFIX + 'DeleteChecked',
  DELETE_CHECKED_ADMIN: PREFIX + 'DeleteCheckedAdmin',
  // CSVファイルを設定
  SET_CSV_FILE: PREFIX + 'SetCsvFile',
  // エラー一覧を設定
  SET_ERR_LIST: PREFIX + 'SetErrList',
  CLEAR: PREFIX + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  ENTER: 'enter',
  RESULT: 'result',
  CSV: 'csv',
  CSV_ERR: 'csvErr',
  CSV_RESULT: 'csvResult',
  NOTUSE: 'notuse'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: '',
  groupNm: '',
  creator: {},
  listUser: [],
  listAdmin: [],
  checkedList: {},
  admincheckedList: {},
  showAll: false,
  showAllAdmin: false,
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  pagingAdmin: {
    viewNum: 50,
    currentPage: 0
  },
  csvFile: null,
  errList: []
};

/**
 * テンプレートファイル名
 */
const TEMPLATE_NM = exports.TEMPLATE_NM = 'group_template.csv';

/**
 * アクション定義
 */
const groupRegisterActions = exports.groupRegisterActions = (0, _reduxActions.createActions)({
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CREATOR]: function () {
    return {
      creator: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_GROUP_NM]: function () {
    return {
      groupNm: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_USERS]: function () {
    return {
      users: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ADMINS]: function () {
    return {
      admins: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL_ADMIN]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKED]: function () {
    return {
      id: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKED_ADMIN]: function () {
    return {
      id: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKED_ALL]: function () {
    return {
      checked: arguments.length <= 0 ? undefined : arguments[0],
      getId: arguments.length <= 1 ? undefined : arguments[1],
      type: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.CHANGE_CHECKED_ALL_ADMIN]: function () {
    return {
      checked: arguments.length <= 0 ? undefined : arguments[0],
      getId: arguments.length <= 1 ? undefined : arguments[1],
      type: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE_ADMIN]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM_ADMIN]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CSV_FILE]: function () {
    return {
      csvFile: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ERR_LIST]: function () {
    return {
      errList: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_PAGING, TYPES.DELETE_CHECKED, TYPES.DELETE_CHECKED_ADMIN, TYPES.CLEAR);

/**
 * Reducer定義
 */
const groupRegisterReducer = exports.groupRegisterReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_CREATOR]: (state, action) => {
    const {
      creator
    } = action.payload;
    const {
      kaishaCd,
      shainId,
      shainNm,
      kaishaNm,
      soshikiNm,
      soshikiNmFull
    } = creator;
    return _objectSpread(_objectSpread({}, state), {}, {
      creator,
      checkedList: {
        [kaishaCd + shainId]: false
      },
      admincheckedList: {
        [kaishaCd + shainId]: false
      },
      listUser: [{
        kaishaCd,
        shainId,
        shainNm,
        kaishaNm,
        soshikiNm,
        soshikiNmFull
      }],
      listAdmin: [{
        kaishaCd,
        shainId,
        shainNm,
        kaishaNm,
        soshikiNm,
        soshikiNmFull
      }]
    });
  },
  [TYPES.SET_GROUP_NM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      groupNm: action.payload.groupNm
    });
  },
  [TYPES.SET_USERS]: (state, action) => {
    const newCheckedList = {};
    action.payload.users.forEach(user => {
      newCheckedList[user.kaishaCd + user.shainId] = false;
    });
    newCheckedList[state.creator.kaishaCd + state.creator.shainId] = false;
    return _objectSpread(_objectSpread({}, state), {}, {
      listUser: [...action.payload.users],
      checkedList: _objectSpread({}, newCheckedList)
    });
  },
  [TYPES.SET_ADMINS]: (state, action) => {
    const newCheckedAdminList = {};
    action.payload.admins.forEach(admin => {
      newCheckedAdminList[admin.kaishaCd + admin.shainId] = false;
    });
    newCheckedAdminList[state.creator.kaishaCd + state.creator.shainId] = false;
    return _objectSpread(_objectSpread({}, state), {}, {
      listAdmin: [...action.payload.admins],
      admincheckedList: _objectSpread({}, newCheckedAdminList)
    });
  },
  [TYPES.CHANGE_CHECKED]: (state, action) => {
    const {
      id
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      checkedList: _objectSpread(_objectSpread({}, state.checkedList), {}, {
        [id]: !state.checkedList[id]
      })
    });
  },
  [TYPES.CHANGE_CHECKED_ADMIN]: (state, action) => {
    const {
      id
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      admincheckedList: _objectSpread(_objectSpread({}, state.admincheckedList), {}, {
        [id]: !state.admincheckedList[id]
      })
    });
  },
  [TYPES.CHANGE_CHECKED_ALL]: (state, action) => {
    let tagetList = state.listUser.slice(state.paging.currentPage * state.paging.viewNum, state.paging.currentPage * state.paging.viewNum + state.paging.viewNum);
    let newListState = _objectSpread({}, state.checkedList);
    tagetList.forEach(data => {
      newListState[action.payload.getId(data)] = action.payload.checked;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      checkedList: _objectSpread({}, newListState)
    });
  },
  [TYPES.CHANGE_CHECKED_ALL_ADMIN]: (state, action) => {
    let tagetList = state.listAdmin.slice(state.pagingAdmin.currentPage * state.pagingAdmin.viewNum, state.pagingAdmin.currentPage * state.pagingAdmin.viewNum + state.pagingAdmin.viewNum);
    let newListState = _objectSpread({}, state.admincheckedList);
    tagetList.forEach(data => {
      newListState[action.payload.getId(data)] = action.payload.checked;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      admincheckedList: _objectSpread({}, newListState)
    });
  },
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const newList = JSON.parse(JSON.stringify(state.listUser)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listUser: [...newList],
      showAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_SHOW_ALL_ADMIN]: (state, action) => {
    const newList = JSON.parse(JSON.stringify(state.listAdmin)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listAdmin: [...newList],
      showAllAdmin: action.payload.showAll
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_PAGE_ADMIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    pagingAdmin: _objectSpread(_objectSpread({}, state.pagingAdmin), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_VIEW_NUM_ADMIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    pagingAdmin: _objectSpread(_objectSpread({}, state.pagingAdmin), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.DELETE_CHECKED]: state => {
    const newList = state.listUser.filter(data => {
      let checkedKey = data.kaishaCd + data.shainId;
      return !state.checkedList[checkedKey];
    });
    const newCheckedList = {};
    newList.forEach(user => {
      newCheckedList[user.kaishaCd + user.shainId] = false;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listUser: [...newList],
      checkedList: _objectSpread({}, newCheckedList)
    });
  },
  [TYPES.DELETE_CHECKED_ADMIN]: state => {
    const newList = state.listAdmin.filter(data => {
      let checkedKey = data.kaishaCd + data.shainId;
      return !state.admincheckedList[checkedKey];
    });
    const newCheckedList = {};
    newList.forEach(user => {
      newCheckedList[user.kaishaCd + user.shainId] = false;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listAdmin: [...newList],
      admincheckedList: _objectSpread({}, newCheckedList)
    });
  },
  [TYPES.SET_CSV_FILE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      csvFile: action.payload.csvFile
    });
  },
  [TYPES.SET_ERR_LIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      errList: action.payload.errList
    });
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);